(function () {
  'use strict';

  // ─── Scroll reveal ─────────────────────────────────────
  function initReveal() {
    var els = document.querySelectorAll('.dsc-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { observer.observe(el); });
  }

  // ─── Filter pills (visual only) ────────────────────────
  function initFilterPills() {
    document.querySelectorAll('.dsc-filter-row').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var pill = e.target.closest('.dsc-filter-pill');
        if (!pill || !row.contains(pill)) return;
        if (pill.tagName === 'A') return; // real links navigate
        e.preventDefault();
        row.querySelectorAll('.dsc-filter-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
      });
    });
  }

  // ─── Sticky nav state ──────────────────────────────────
  function initNavShadow() {
    var nav = document.querySelector('.dsc-nav');
    if (!nav) return;

    var ann = document.querySelector('.dsc-ann-bar');
    function syncAnnHeight() {
      var h = ann ? ann.offsetHeight : 0;
      document.documentElement.style.setProperty('--dsc-ann-height', h + 'px');
    }
    syncAnnHeight();
    window.addEventListener('resize', syncAnnHeight, { passive: true });

    var onScroll = function () {
      var annHeight = ann ? ann.offsetHeight : 0;
      nav.classList.toggle('is-scrolled', window.scrollY > annHeight);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ─── Drawer (hamburger menu) ───────────────────────────
  function initDrawer() {
    var drawer = document.querySelector('[data-dsc-drawer]');
    if (!drawer) return;
    var opens = document.querySelectorAll('[data-dsc-menu-open]');
    var closes = document.querySelectorAll('[data-dsc-menu-close]');

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    opens.forEach(function (b) { b.addEventListener('click', open); });
    closes.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  // ─── PDP: scroll gallery to selected variant's featured_media ─────
  // Canonical Shopify approach (from Manhattan/Dawn/etc):
  // 1. Read product.variants JSON embedded in the page
  // 2. Find the current variant by ID
  // 3. Look up its featured_media.id
  // 4. Scroll the gallery item with matching data-media-id into view at the top
  // No filtering/hiding — all images stay visible, we just SCROLL to the right one.
  function initPdpMedia() {
    var mediaContainer = document.querySelector('[data-pdp-media]');
    if (!mediaContainer) return;

    var jsonScript = document.querySelector('[data-pdp-variants-json]');
    if (!jsonScript) return;

    var variants;
    try {
      variants = JSON.parse(jsonScript.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    function scrollToVariantMedia(variantId, behavior) {
      if (!variantId) return;
      var vid = parseInt(variantId, 10);
      var variant = variants.find(function (v) { return v.id === vid; });
      if (!variant) return;
      if (!variant.featured_media) return;

      var targetMediaId = String(variant.featured_media.id);
      var targetItem = mediaContainer.querySelector('[data-media-id="' + targetMediaId + '"]');
      if (!targetItem) return;

      // The gallery uses internal scroll with scroll-snap. Direction depends on screen size:
      // desktop = vertical (scroll top), mobile = horizontal (scroll left).
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var scrollBehavior = behavior || 'smooth';
      if (isMobile) {
        mediaContainer.scrollTo({ left: targetItem.offsetLeft, behavior: scrollBehavior });
      } else {
        mediaContainer.scrollTo({ top: targetItem.offsetTop, behavior: scrollBehavior });
      }

      mediaContainer.setAttribute('data-current-variant', vid);
    }

    // Initial scroll on page load.
    // Mobile is tricky: the horizontal gallery uses aspect-ratio for sizing, images load
    // asynchronously, and iOS Safari scroll-snap can resist programmatic scrolling.
    // Strategy: try once on next frame (might work for cached images), then retry after
    // window.load (all images decoded), and verify scrollLeft actually landed correctly.
    var initial = mediaContainer.getAttribute('data-current-variant');
    if (initial) {
      var attempts = 0;
      function tryInitialScroll() {
        attempts++;
        scrollToVariantMedia(initial, 'instant');

        // Verify we landed correctly; if not, retry
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (!isMobile || attempts >= 6) return;
        var vid = parseInt(initial, 10);
        var variant = variants.find(function (v) { return v.id === vid; });
        if (!variant || !variant.featured_media) return;
        var targetItem = mediaContainer.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (!targetItem) return;
        var expected = targetItem.offsetLeft;
        var actual = mediaContainer.scrollLeft;
        if (Math.abs(expected - actual) > 4) {
          setTimeout(tryInitialScroll, 80 * attempts);
        }
      }
      requestAnimationFrame(tryInitialScroll);
      // After window.load, all images are decoded and layout is final
      if (document.readyState !== 'complete') {
        window.addEventListener('load', function () {
          setTimeout(tryInitialScroll, 50);
        });
      } else {
        setTimeout(tryInitialScroll, 100);
      }
    }

    // Listen for variant changes
    var section = mediaContainer.closest('.shopify-section') || document;
    section.addEventListener('variant:update', function (e) {
      var newId = e.detail && e.detail.resource && e.detail.resource.id;
      if (newId) scrollToVariantMedia(newId);
    });

    // Our own custom event dispatched by the variant picker fallback when
    // color changes (rotation mode, no reload). Carries the new variant ID.
    document.addEventListener('dsc:variant-change', function (e) {
      var newId = e.detail && e.detail.variantId;
      if (newId) scrollToVariantMedia(newId);
    });

    var variantInput = document.querySelector('input[name="id"][ref="variantId"]');
    if (variantInput) {
      var observer = new MutationObserver(function () {
        if (variantInput.value) scrollToVariantMedia(variantInput.value);
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  // ─── Bulletproof variant picker: reload page on COLOR swatch change ─
  // Color changes need a full reload to sync price/image/availability.
  // Size changes (dropdown) do NOT reload — they just update the hidden variant ID
  // silently so Add to Bag works with the right variant.
  function initVariantPickerFallback() {
    var pickerForm = document.querySelector('.dsc-pdp-variant-form, .dsc-pdp-variants');
    if (!pickerForm) return;

    // Load the variants JSON so we can resolve cross-axis variants
    // (e.g. "the Black variant with Size M" when user clicks Black while M is picked).
    var variants = null;
    var jsonScript = document.querySelector('[data-pdp-variants-json]');
    if (jsonScript) {
      try { variants = JSON.parse(jsonScript.textContent); } catch (e) {}
    }

    // Use product handle as the key for size persistence (so size doesn't leak across products)
    function getProductKey() {
      var path = window.location.pathname;
      var m = path.match(/\/products\/([^\/?#]+)/);
      return m ? 'dsc_size_' + m[1] : null;
    }

    function rememberSize(sizeValue) {
      var key = getProductKey();
      if (!key) return;
      try { sessionStorage.setItem(key, sizeValue); } catch (e) {}
    }

    function getRememberedSize() {
      var key = getProductKey();
      if (!key) return null;
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }

    // Given a target option value (e.g. new color "Navy") and which option position it's for,
    // find the variant that matches the new value PLUS keeps the currently-selected size.
    function findCrossVariant(targetOptionValue, targetOptionPosition) {
      if (!variants || !variants.length) return null;
      var rememberedSize = getRememberedSize();
      if (!rememberedSize) return null;

      // Find a variant whose targetOptionPosition matches targetOptionValue
      // AND whose Size option equals rememberedSize
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || !v.available) continue;
        // v.options is an array indexed by option position (0, 1, 2...)
        // v.option1, v.option2, v.option3 are also available
        var matches = true;
        // Check the target axis matches the clicked value
        if (v['option' + targetOptionPosition] !== targetOptionValue) {
          matches = false;
        }
        // Check that the size axis matches our remembered size
        // Find which option position is Size by examining variant's options
        // Size value is usually one of S/M/L/XL/2XL/3XL/4XL
        if (matches) {
          var hasSize = false;
          for (var p = 1; p <= 3; p++) {
            if (v['option' + p] === rememberedSize) { hasSize = true; break; }
          }
          if (!hasSize) matches = false;
        }
        if (matches) return v;
      }
      return null;
    }

    function getVariantIdFromInput(input) {
      if (!input) return null;
      return input.getAttribute('data-variant-id');
    }

    function reloadWithVariant(variantId) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.location.href = url.toString();
    }

    function updateSizeLabel(newSizeText) {
      var sizeSelect = pickerForm.querySelector('[data-size-select]');
      if (!sizeSelect) return;
      var wrapper = sizeSelect.closest('.dsc-pdp-option');
      if (!wrapper) return;
      var labelTarget = wrapper.querySelector('.dsc-pdp-option-selected');
      if (labelTarget) labelTarget.textContent = newSizeText;
    }

    // ── Soft color change (no reload): rotate gallery, sync labels/URL/hidden input ──
    // Matches ALD's instant feel — no white flash, no scroll jump.
    function softUpdateColor(newVariantId, newColorValue) {
      if (!newVariantId) return;

      // 1. Update the hidden variant input so Add to Bag submits the correct variant
      var hiddenInput = document.querySelector('input[name="id"][ref="variantId"]');
      if (hiddenInput) hiddenInput.value = newVariantId;

      // 2. Update the URL silently (no reload) so refresh keeps the choice
      var url = new URL(window.location.href);
      url.searchParams.set('variant', newVariantId);
      window.history.replaceState({}, '', url.toString());

      // 3. Update all "Color: ___" labels (both desktop swatch legend and mobile dropdown label)
      if (newColorValue) {
        var colorLabelTargets = document.querySelectorAll(
          '.dsc-pdp-option--swatch .dsc-pdp-option-selected, ' +
          '.dsc-pdp-option--mobile-color .dsc-pdp-option-selected, ' +
          '.dsc-pdp-buy-title' // mobile sticky title doesn't include color, leave alone
        );
        // Only update the color-specific labels (not the product title)
        document.querySelectorAll(
          '.dsc-pdp-option--swatch .dsc-pdp-option-selected, ' +
          '.dsc-pdp-option--mobile-color .dsc-pdp-option-selected'
        ).forEach(function (el) {
          el.textContent = newColorValue;
        });
      }

      // 4. Sync the swatch :checked state so the visible ring moves to the new color
      var swatchInputs = document.querySelectorAll('.dsc-pdp-swatch-input');
      swatchInputs.forEach(function (input) {
        input.checked = (input.value === newColorValue);
      });

      // 5. Sync the mobile color dropdown's selected option
      var mobileColorSelect = document.querySelector('[data-mobile-color-select]');
      if (mobileColorSelect && newColorValue) {
        for (var i = 0; i < mobileColorSelect.options.length; i++) {
          if (mobileColorSelect.options[i].value === newColorValue) {
            mobileColorSelect.selectedIndex = i;
            break;
          }
        }
      }

      // 6. Dispatch event so initPdpMedia's listener scrolls the gallery
      document.dispatchEvent(new CustomEvent('dsc:variant-change', {
        detail: { variantId: newVariantId, colorValue: newColorValue }
      }));
    }

    // ── Size is never pre-selected on page load ────────────────────
    // The customer must always choose a size deliberately.
    // (rememberSize/getRememberedSize are kept only for cross-axis variant
    // resolution when switching colors — they no longer auto-fill the dropdown.)

    // Use 'change' event on the form which catches both radio and select changes
    pickerForm.addEventListener('change', function (e) {
      var target = e.target;

      // ── SIZE DROPDOWN: silent update, no reload ─────────────────
      if (target.matches('select[data-size-select]')) {
        var opt = target.options[target.selectedIndex];
        if (!opt || !opt.value) return;
        var newSizeValue = opt.value;

        // The option's data-variant-id defaults to the FIRST color for this size,
        // which is wrong when the user is viewing a different color.
        // Strategy: read the CURRENT variant from the hidden input (most reliable
        // source — always set by softUpdateColor or page load), find which color
        // options it has, then find the variant with SAME color + new size.
        var hiddenInput = document.querySelector('input[name="id"][ref="variantId"]');
        var currentVid = hiddenInput ? hiddenInput.value : null;
        var newVid = null;

        if (currentVid && variants && variants.length) {
          // Find the current variant to read its color option(s)
          var currentVariant = null;
          for (var ci = 0; ci < variants.length; ci++) {
            if (String(variants[ci].id) === String(currentVid)) {
              currentVariant = variants[ci];
              break;
            }
          }
          if (currentVariant && currentVariant.options) {
            // Find a variant that shares ALL option values with the current one
            // EXCEPT the size axis, which gets the new size value.
            for (var vi = 0; vi < variants.length; vi++) {
              var v = variants[vi];
              if (!v.options) continue;
              // Check: same options as current, but with newSizeValue swapped in
              var isMatch = true;
              for (var oi = 0; oi < v.options.length; oi++) {
                if (v.options[oi] === newSizeValue) continue; // this is the size axis
                if (v.options[oi] === currentVariant.options[oi]) continue; // same as current
                isMatch = false;
                break;
              }
              // Confirm the new size is actually in this variant
              if (isMatch && v.options.indexOf(newSizeValue) !== -1) {
                newVid = String(v.id);
                break;
              }
            }
          }
        }

        // Fallback to the option's own variant-id if cross-lookup failed
        if (!newVid) newVid = opt.getAttribute('data-variant-id');
        if (!newVid) return;

        if (hiddenInput) hiddenInput.value = newVid;

        updateSizeLabel(newSizeValue);
        rememberSize(newSizeValue); // Persist across reloads

        var url = new URL(window.location.href);
        url.searchParams.set('variant', newVid);
        window.history.replaceState({}, '', url.toString());

        var atbBtn = document.querySelector('.dsc-pdp-atc-btn');
        if (atbBtn) atbBtn.classList.add('dsc-pdp-atc-btn--ready');

        // Re-affirm gallery position so scroll-snap doesn't reset to first image
        document.dispatchEvent(new CustomEvent('dsc:variant-change', {
          detail: { variantId: newVid }
        }));

        return;
      }

      // ── MOBILE COLOR DROPDOWN: reload, preserving size if possible ─
      if (target.matches('select[data-mobile-color-select]')) {
        var opt = target.options[target.selectedIndex];
        if (!opt) return;
        var newVid = opt.getAttribute('data-variant-id');

        // Try to find a variant matching (new color, current saved size)
        var optPos = parseInt(target.getAttribute('data-option-position') || '0', 10);
        if (opt.value && optPos) {
          var crossVariant = findCrossVariant(opt.value, optPos);
          if (crossVariant) newVid = crossVariant.id;
        }

        // Defensive fallback: if data-variant-id was empty, pick first available variant
        if (!newVid && variants && opt.value && optPos) {
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (v['option' + optPos] === opt.value && v.available) {
              newVid = v.id;
              break;
            }
          }
        }

        if (!newVid) return;

        var hiddenInput = document.querySelector('input[name="id"][ref="variantId"]');
        var currentVid = hiddenInput ? hiddenInput.value : null;
        if (String(newVid) === currentVid) return;

        softUpdateColor(newVid, opt.value);
        return;
      }

      // ── COLOR SWATCH or fallthrough DROPDOWN: reload, preserving size if possible ───
      var newVid = null;
      var clickedValue = null;
      var clickedPos = null;
      if (target.matches('input[type="radio"]')) {
        newVid = getVariantIdFromInput(target);
        clickedValue = target.value;
        clickedPos = parseInt(target.getAttribute('data-fieldset-index') || '0', 10) + 1;
      } else if (target.matches('select')) {
        var opt = target.options[target.selectedIndex];
        newVid = opt ? opt.getAttribute('data-variant-id') : null;
        clickedValue = opt ? opt.value : null;
        // Derive position from data-input-id (format: "position-index")
        if (opt) {
          var inputId = opt.getAttribute('data-input-id') || '';
          var posMatch = inputId.match(/^(\d+)-/);
          if (posMatch) clickedPos = parseInt(posMatch[1], 10);
        }
      }

      // Try cross-axis match if we have the metadata
      if (clickedValue && clickedPos) {
        var crossVariant = findCrossVariant(clickedValue, clickedPos);
        if (crossVariant) newVid = crossVariant.id;
      }

      // Defensive fallback: if newVid is still null AND we know the clicked value+position,
      // pick the first available variant matching that axis from the JSON.
      if (!newVid && variants && clickedValue && clickedPos) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v['option' + clickedPos] === clickedValue && v.available) {
            newVid = v.id;
            break;
          }
        }
      }

      if (!newVid) return;

      var hiddenInput = document.querySelector('input[name="id"][ref="variantId"]');
      var currentVid = hiddenInput ? hiddenInput.value : null;
      if (String(newVid) === currentVid) return;

      softUpdateColor(newVid, clickedValue);
    });

    // ── iOS belt-and-suspenders: direct click on swatch labels ─────
    // Some mobile browsers don't fire 'change' reliably on hidden radio inputs
    // when triggered via label tap. Listen on the label directly.
    var swatchLabels = pickerForm.querySelectorAll('.dsc-pdp-swatch-label');
    swatchLabels.forEach(function (label) {
      label.addEventListener('click', function (e) {
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;

        var clickedValue = input.value;
        var clickedPos = parseInt(input.getAttribute('data-fieldset-index') || '0', 10) + 1;
        var vid = input.getAttribute('data-variant-id');

        // Try cross-axis match — preserve current size if one is remembered
        if (clickedValue && clickedPos) {
          var crossVariant = findCrossVariant(clickedValue, clickedPos);
          if (crossVariant) vid = crossVariant.id;
        }

        // Last-resort fallback: if data-variant-id was missing AND cross-variant
        // didn't match (e.g. no size remembered), find ANY available variant with
        // this clicked value on the clicked axis
        if (!vid && variants && clickedValue && clickedPos) {
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (v['option' + clickedPos] === clickedValue && v.available) {
              vid = v.id;
              break;
            }
          }
        }

        if (!vid) return;

        var hiddenInput = document.querySelector('input[name="id"][ref="variantId"]');
        var currentVid = hiddenInput ? hiddenInput.value : null;
        if (String(vid) === currentVid) return;

        // Do NOT preventDefault — let the browser check the radio naturally
        // so the CSS :checked ring updates immediately. The change listener's
        // early-exit guard (currentVid === newVid) prevents double processing.
        softUpdateColor(vid, clickedValue);
      });
    });

    // ── Block Add to Bag until size is picked ──────────────────────
    var sizeSelect = pickerForm.querySelector('[data-size-select]');
    if (sizeSelect) {
      // On page load, the hidden variant input is populated by Shopify with the
      // first available variant (smallest size). But our dropdown shows "Select Size"
      // as the default — meaning the user hasn't actually picked. Clear the hidden
      // input to enforce that they must pick a size before Add to Bag works.
      if (!sizeSelect.value) {
        var hiddenInput = document.querySelector('input[name="id"][ref="variantId"]');
        if (hiddenInput) hiddenInput.value = '';
      }

      // Find the ATB button — could be inside or outside the picker form
      var atbBtn = document.querySelector('.dsc-pdp-atc-btn');
      if (atbBtn) {
        atbBtn.addEventListener('click', function (e) {
          if (!sizeSelect.value) {
            e.preventDefault();
            e.stopPropagation();
            // Flash the dropdown to draw attention
            var wrapper = sizeSelect.closest('.dsc-pdp-select-wrap');
            if (wrapper) {
              wrapper.classList.add('dsc-pdp-select-wrap--error');
              setTimeout(function () {
                wrapper.classList.remove('dsc-pdp-select-wrap--error');
              }, 1200);
            }
            sizeSelect.focus();
          }
        }, true); // capture phase so we run before the form submit handler
      }
    }
  }

  // ─── Sync nav cart count on add-to-cart / cart updates ─
  function initCartCount() {
    function updateAll(count) {
      var nodes = document.querySelectorAll('[data-cart-count]');
      nodes.forEach(function (el) { el.textContent = count; });
    }

    // CartAddEvent and CartUpdateEvent both dispatch 'cart:update' (bubbles to document).
    // The cart-drawer-component already has its own auto-open listener for CartAddEvent,
    // so we ONLY handle the cart count update here — never try to open the drawer manually
    // (that breaks its side-panel positioning).
    document.addEventListener('cart:update', function (e) {
      var detail = e.detail || {};
      var newCount = null;
      if (detail.resource && typeof detail.resource.item_count === 'number') {
        newCount = detail.resource.item_count;
      } else if (detail.data && typeof detail.data.itemCount === 'number') {
        newCount = detail.data.itemCount;
      }
      if (newCount !== null) {
        updateAll(newCount);
        return;
      }
      // Fallback: fetch /cart.js for the count
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') updateAll(cart.item_count);
        })
        .catch(function () {});
    });

    // When the user clicks the Bag/Cart nav button, open the drawer (don't navigate).
    // Also force a fresh re-render of cart contents because the drawer's HTML was
    // rendered at page load time with empty-cart state — it won't auto-update otherwise.
    // Covers both: <a href="/cart"> links AND the .dsc-nav-cart button (which uses
    // Shopify's on:click="#DSCCartDrawer/showDialog" declarative syntax).
    var bagLinks = document.querySelectorAll('a[href="/cart"], a[href$="/cart"], .dsc-nav-cart');
    bagLinks.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var drawer = document.getElementById('DSCCartDrawer');
        if (!drawer) return;
        if (typeof drawer.showDialog === 'function') {
          e.preventDefault();
          e.stopPropagation(); // Prevent Shopify's on:click from also firing
          refreshCartDrawer().finally(function () {
            try { drawer.showDialog(); } catch (err) {}
          });
        }
      }, true); // Capture phase: run before Shopify's on:click handler
    });

    // Re-render cart drawer contents from /cart fetched HTML
    function refreshCartDrawer() {
      return fetch('/?sections=' + getCartSectionId(), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data) return;
          var sectionId = getCartSectionId();
          var html = data[sectionId];
          if (!html) return;
          // Parse the HTML and find the cart-drawer__inner block
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
          var currentInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
          if (newInner && currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }
          // Also update the dialog's empty-state class
          var newDialog = doc.querySelector('.cart-drawer__dialog');
          var currentDialog = document.querySelector('.cart-drawer__dialog');
          if (newDialog && currentDialog) {
            if (newDialog.classList.contains('cart-drawer--empty')) {
              currentDialog.classList.add('cart-drawer--empty');
            } else {
              currentDialog.classList.remove('cart-drawer--empty');
            }
          }
        })
        .catch(function () {});
    }

    function getCartSectionId() {
      // The cart drawer is rendered inside the dsc-header section
      var header = document.querySelector('.shopify-section[id*="header"]');
      if (header && header.id) return header.id.replace('shopify-section-', '');
      return 'dsc-header';
    }

    // Refresh drawer contents on cart:update
    document.addEventListener('cart:update', function () {
      refreshCartDrawer();
    });
  }

  function init() {
    initReveal();
    initFilterPills();
    initNavShadow();
    initDrawer();
    initPdpMedia();
    initCartCount();
    initVariantPickerFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initFilterPills();
    initNavShadow();
    initDrawer();
    initPdpMedia();
    initCartCount();
    initVariantPickerFallback();
  });
})();